var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedSupplier ? '编辑' : '新增'}供应商`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "供应商",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请填写供应商名"
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "供应商简称",
      "prop": "abbr"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请填写供应商简称"
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }